import { ref } from "vue";
import { defineStore } from "pinia";
import isSpacedString from "@/helpers/isSpacedString";

import type { Corporation } from "@/interfaces/corporation";

export const useCorporationsSearchStore = defineStore("Corporations", () => {
  const query = ref("");
  const corporations = ref<Corporation[]>([]);

  return {
    query,
    corporations,

    setQuery(value: string) {
      if (!isSpacedString(value)) {
        query.value = value;
      }
    },
    setCorporations(value: Corporation[] | undefined) {
      corporations.value = value || [];
    },
    resetState() {
      query.value = "";
      corporations.value = [];
    },
  };
});
